// extracted by mini-css-extract-plugin
export default {"shoppingCart":"styles_shoppingCart__QxKk9"};